import Whatsapp from '@source/components/SVGs/Whatsapp';
import * as S from './styles';

type CompanyWhatsappButtonProps = {
  customButtonStyle?: React.CSSProperties;
  customAction: () => void;
};

const CompanyWhatsappButton: React.FC<CompanyWhatsappButtonProps> = ({
  customButtonStyle,
  customAction
}): JSX.Element => {
  return (
    <S.WhatsappButton style={{ ...customButtonStyle }} onClick={customAction}>
      <Whatsapp />
    </S.WhatsappButton>
  );
};

export default CompanyWhatsappButton;
